import React, {useState} from 'react'
import { AppUseNotification } from 'app/pages/component/AppUseNotification'
import { Header } from '../../component/Header'
import { Sidebar } from '../../component/Sidebar'
export const MainWrapper = ({children}) => {
    const [isOpen, setIsOpen] = useState(true)
    const HandleOpen = () => {
        setIsOpen(!isOpen)
    }
  return (
    <>
    <AppUseNotification></AppUseNotification>
    
    <Sidebar isOpen = {isOpen} HandleOpen = {HandleOpen} />
    <Header isOpen = {isOpen} />
    <main className={`${isOpen ? 'pl-52': 'pl-20'} duration-300 bg-white px-8`}>
          {children}
        </main>
      
    </>
    
  )
}
